/** Main elib API (grantha, bidhi, puja, karmakanda, etc.) */
// export const API_URL =
//   process.env.NODE_ENV === 'production'
//     ? 'https://elibapi.vag.org.np'
//     : 'https://elibapi.vag.org.np';


export const API_URL = 'https://elibapidev.vag.org.np'

/** Central auth API (login, profile, gotra) */
export const AUTH_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://centralauthdev.vag.org.np'
    : 'https://centralauthdev.vag.org.np';
